import React, {FC} from 'react';
import cn from 'classnames';
import {LocationPoint, LocationSuperiorsList} from '@/common/interfaces/location';
import {MapLocationDialect} from '@/app/interfaces/map';
import {useLocalizer} from '@/common/services/localizer';
import {MapLocationsList} from '../MapLocationsList';
import styles from './MapSubordinatesList.css';
import {LocationType} from '@/common/constants/locationType';
import {LocationLink} from '@/app/components/common/LocationLink';

interface MapSubordinatesListProps {
	location: LocationPoint;
	locationSuperiors: LocationSuperiorsList;
	dialect: MapLocationDialect;
	largest: LocationPoint[];
	subordinates: LocationPoint[];
	continents?: LocationPoint[];
}

export const MapSubordinatesList: FC<MapSubordinatesListProps> = props => {
	const {location, locationSuperiors, dialect, largest, subordinates, continents} = props;

	const t = useLocalizer();
	const superiorTitleGc = locationSuperiors.region?.titleGc || locationSuperiors.country?.titleGc;
	const locationTitlePc =
		location.titleGc || (superiorTitleGc ? `${superiorTitleGc}, ${location.title}` : location.titleLc);

	return (
		<div>
			{largest.length > 0 && (
				<>
					<h2 className={styles.title}>
						{t('weatherInPopularSettlements')} {locationTitlePc}
					</h2>
					<MapLocationsList columns={6} locations={largest} />
				</>
			)}

			{subordinates.length > 0 && (
				<>
					<h2 className={styles.title}>
						{location.type === LocationType.District &&
							`${dialect.subDistrict?.titlePc || ''} ${locationTitlePc}`}

						{location.type === LocationType.Region &&
							`${dialect.district?.titlePc || ''} ${locationTitlePc}`}

						{location.type === LocationType.Country &&
							`${dialect.region?.titlePc || ''} ${locationTitlePc}`}

						{location.type === LocationType.Continent && t('countriesOf', {country: locationTitlePc})}
					</h2>
					<MapLocationsList columns={6} locations={subordinates} />
				</>
			)}

			{continents && continents.length > 0 && (
				<div>
					<h2 className={cn(styles.title, styles.isInline)}>{t('otherContinent')}</h2>
					{continents
						.filter(item => item.id !== location.id)
						.map(item => (
							<LocationLink key={item.id} className={styles.inlineLink} location={item} />
						))}
				</div>
			)}
		</div>
	);
};

MapSubordinatesList.displayName = 'MapSubordinatesList';
